import { render } from "./user.vue?vue&type=template&id=598bb1bc&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import "./user.vue?vue&type=style&index=0&id=598bb1bc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-598bb1bc"

export default script